import React, {useMemo} from "react";
import S from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {Button, Input} from "@chakra-ui/react";
import {useLanguage} from "@/contexts/languageContext";

export const DatePicker = ({date, onChange, label, ...props}) => {

    const { t } = useLanguage();

    const CustomInput = React.forwardRef(
        ({ value, onClick, disabled = false }, ref) => {
            return (
                <Button
                    disabled={disabled}
                    onClick={(e) => {
                        e.stopPropagation() && e.preventDefault();
                        onClick(e);
                    }}
                    color="unset"
                    bg="transparent"
                    p={0}
                    m={0}
                >
                    <Input pointerEvents="none" defaultValue={value} disabled={disabled} ref={ref}/>
                </Button>
            );
        }
    );

    const parsedProps = useMemo(() => {
        if('minDate' in props && props?.showTimeSelect){
            props.filterTime = (time) => {
                const currentDate = new Date(props.minDate);
                const selectedDate = new Date(time);
                return currentDate.getTime() < selectedDate.getTime();
            }
        }
        return props;
    }, [props])

    return (
        <S
            selected={date}
            onChange={(date) => onChange(date)}
            showMonthYearDropdown={false}
            {...parsedProps}
            withPortal={true}
            timeCaption={t('fields.hour')}
            customInput={<CustomInput/>}
        />
    );
};

export default DatePicker;
